import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class ApiService {

  constructor(private httpService: HttpService, private authService: AuthService) { }

  verifyAccount(token: string, language: string): Observable<any> {
    const url = `${this.authService.getApiUrl()}/users/verifyAccount`;
    const payload = { 
      token: token,
      language: language
    };
    return this.httpService.doPost(url, payload, null);
  }
}
